module.exports = __webpack_public_path__ + "img/tuxiangtitle.6944a544.png";